export const FETCH_RATEADMIN_ADVANCERATE_LIST = {
  START: 'FETCH_RATEADMIN_ADVANCERATE_LIST_START',
  SUCCESS: 'FETCH_RATEADMIN_ADVANCERATE_LIST_SUCCESS',
  ERROR: 'FETCH_RATEADMIN_ADVANCERATE_LIST_ERROR',
};

export const TOAST = {
  RESET: 'RESET_TOAST',
};

export const FETCH_RATEADMIN_ADVANCERATE_INIT = "FETCH_RATEADMIN_ADVANCERATE_INIT";

export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY = 'SET_ADVANCERATE_DELETE_CONFIRMATION_POPUP_VISIBILITY';

export const INIT_CREATE_RATEADMIN_ADVANCERATE_SCREEN = 'INIT_CREATE_RATEADMIN_ADVANCERATE_SCREEN';

export const CREATE_RATEADMIN_ADVANCERATE = {
  START: 'CREATE_RATEADMIN_ADVANCERATE_START',
  SUCCESS: 'CREATE_RATEADMIN_ADVANCERATE_SUCCESS',
  ERROR: 'CREATE_RATEADMIN_ADVANCERATE_ERROR',
};

export const EDIT_RATEADMIN_ADVANCERATE = {
  START: 'EDIT_RATEADMIN_ADVANCERATE_START',
  SUCCESS: 'EDIT_RATEADMIN_ADVANCERATE_SUCCESS',
  ERROR: 'EDIT_RATEADMIN_ADVANCERATE_ERROR',
};

export const FETCH_RATEADMIN_ADVANCERATE_DETAIL = {
  START: 'FETCH_RATEADMIN_ADVANCERATE_DETAIL_START',
  SUCCESS: 'FETCH_RATEADMIN_ADVANCERATE_DETAIL_SUCCESS',
  ERROR: 'FETCH_RATEADMIN_ADVANCERATE_DETAIL_ERROR',
};

export const EXPORT_RATEADMIN_ADVANCERATE = {
  START: 'EXPORT_RATEADMIN_ADVANCERATE_START',
  SUCCESS: 'EXPORT_RATEADMIN_ADVANCERATE_SUCCESS',
  ERROR: 'EXPORT_RATEADMIN_ADVANCERATE_ERROR',
};

export const RATEADMIN_ADVANCERATEDD = {
  START: 'RATEADMIN_ADVANCERATEDD_START',
  SUCCESS: 'RATEADMIN_ADVANCERATEDD_SUCCESS',
  ERROR: 'RATEADMIN_ADVANCERATEDD_ERROR',
};

export const RATEADMIN_ADVANCERATE_DELETE = {
  START: 'RATEADMIN_ADVANCERATE_DELETE_START',
  SUCCESS: 'RATEADMIN_ADVANCERATE_DELETE_SUCCESS',
  ERROR: 'RATEADMIN_ADVANCERATE_DELETE_ERROR',
};

export const SEARCH_ADVANCE_RATE = {
  START: 'SEARCH_ADVANCE_RATE_START',
  SUCCESS: 'SEARCH_ADVANCE_RATE_SUCCESS',
  ERROR: 'SEARCH_ADVANCE_RATE_ERROR',
};

export const UPDATE_ADVANCE_RATE = {
  START: 'UPDATE_ADVANCE_RATE_START',
  SUCCESS: 'UPDATE_ADVANCE_RATE_SUCCESS',
  ERROR: 'UPDATE_ADVANCE_RATE_ERROR',
};

export const RATEADMIN_ADVANCERATE_SAVE_TABLE_STATE = 'RATEADMIN_ADVANCERATE_SAVE_TABLE_STATE';
